<template>
    <div class="mainTabs-wrapper">
        <div v-if="isZeepliveBoxVisible">
            <div id="parentTabIn" class="parentTabIn" style="padding-top: 35px;">
                <span class="backArrowIcon" id="close" @click="viewClose('someStatus')">
                    <img :src="downArrow" alt="Back Arrow" />
                </span>
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item" style="display: none">
                        <div class="nav-link" :class="{ active: activeTab === 'charmTab' }"
                            @click="activateTab('charmTab')" role="tab">
                            Charm
                        </div>
                    </li>

                    <li class="nav-item" style="display: none">
                        <div class="nav-link" :class="{ active: activeTab === 'richTab' }"
                            @click="activateTab('richTab')" role="tab">
                            Rich
                        </div>
                    </li>

                    <li class="nav-item" style="display: none;">
                        <div class="nav-link" :class="{ active: activeTab === 'roomTab' }"
                            @click="activateTab('roomTab')" role="tab">
                            Room
                        </div>
                    </li>

                    <li class="nav-item" style="display: none">
                        <div class="nav-link" :class="{ active: activeTab === 'callTab' }"
                            @click="activateTab('callTab')" role="tab">
                            Call
                        </div>
                    </li>

                    <li class="nav-item">
                        <div class="nav-link" :class="{ active: activeTab === 'agencyTab' }"
                            @click="activateTab('agencyTab')" role="tab">
                            Top Agency
                        </div>
                    </li>
                </ul>
                <!-- no duplicate id -->
                <div class="rankRewardInfoBtn" @click="showRankRewardInfoTab">
                    <div class="header-infoIcon">
                        <img :src="infoIcon" alt="Info Icon" />
                    </div>
                </div>
            </div>

            <div class="tab-content">
                <div class="tab-pane" :class="{ 'active show': activeTab === 'charmTab' }" id="charmTab">
                    <div class="tab-contentIn" v-if="isLoadedCharmTab">
                        <Charm />
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'richTab' }" id="richTab" role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedRichTab">
                        <!-- <Rich /> -->
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'roomTab' }" id="roomTab" role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedRoomTab">
                        <!-- <Room /> -->
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'callTab' }" id="callTab" role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedCallTab">
                        <!-- <Call /> -->
                    </div>
                </div>
                <div class="tab-pane" :class="{ 'active': activeTab === 'agencyTab' }" id="agencyTab" role="tabpanel">
                    <div class="tab-contentIn" v-if="isLoadedAgencyTab">
                        <Agency />
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="rankRewardInfoScreen">

            <div class="tab-contentIn">
                <div class="">
                    <div class="headerWrapper rankRewardTopSec">
                        <div id="goParentTab" @click="goBackToAgencyTab" class="backArrowIcon">
                            <img :src="downArrow" alt="Back Arrow" />
                        </div>
                        <div class="rankingReward-HD">Ranking Rewards</div>
                    </div>

                    <div class="rankRewardContSec" v-if="isLoadedRankRewardInfoTab">
                        <AgencyRankRewardInfoComponent :currentTab="activeTab" @tab-changed="handleTabChange" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import downArrow from '../../assets/images/downArrow.png';
import downArrow from '../../assets/images/back-blackArrow.svg';
import infoIcon from '../../assets/images/infoIcon.png';
import Charm from '../Charm/CharmCompTab.vue';
// import Rich from '../Rich/RichCompTab.vue';
// import Room from '../Room/RoomCompTab.vue';
// import Call from '../Call/CallCompTab.vue';
import Agency from '../Agency/AgencyCompTab.vue';
// import RankRewardInfoComponent from '../RankRewardInfoComponent/RankRewardInfoComponent.vue'
import AgencyRankRewardInfoComponent from '../RankRewardInfoComponent/AgencyRankRewardInfoComponent.vue'
export default {
    name: "ParentTabComponentAgency",
    components: {
        Charm,
        // Rich,
        // Room,
        // Call,
        Agency,
        // RankRewardInfoComponent
        AgencyRankRewardInfoComponent
    },
    data() {
        return {
            activeTab: "agencyTab",
            isZeepliveBoxVisible: true,
            downArrow,
            infoIcon,

            isLoadedCharmTab: false,
            isLoadedRichTab: false,
            isLoadedRoomTab: false,
            isLoadedCallTab: false,
            isLoadedAgencyTab: false,
            isLoadedRankRewardInfoTab: false,
        };
    },
    mounted() {
        this.isLoadedAgencyTab = true;
    },
    methods: {
        showRankRewardInfoTab() {
            this.isZeepliveBoxVisible = false;
            this.isLoadedRankRewardInfoTab = true;
        },
        goBackToAgencyTab() {
            this.isZeepliveBoxVisible = true;
            this.activateTab("agencyTab");
        },
        activateTab(tabId) {
            this.isZeepliveBoxVisible = true;
            this.activeTab = tabId;

            if (tabId === "charmTab") this.isLoadedCharmTab = true;
            if (tabId === "richTab") this.isLoadedRichTab = true;
            if (tabId === "roomTab") this.isLoadedRoomTab = true;
            if (tabId === "callTab") this.isLoadedCallTab = true;
            if (tabId === "agencyTab") this.isLoadedAgencyTab = true;
        },
        handleTabChange(tabId) {
            this.activateTab(tabId);
        },
        viewClose(status) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                Android.viewClose(status);
            }
        },
    },
};
</script>
